// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"

export const LightningEntityOption = (props) => {

    
    const [enviromentList, setEnviromentList] = useState([]);
    const [indexNum, setIndexNum] = useState("");

    useEffect(() => {
        setEnviromentList(props.enviromentList);
        setIndexNum(props.indexNum);
    }, [props])
   
    let field = enviromentList[indexNum];

    if (field) {
        return (
            <Dialog header="閃電參數設定"  visible={props.LightningEntity} style={{ width: '25%' }} position={'right'} modal={false} keepInViewport={false} onHide={() => props.onHide('LightningEntity')}>
                <Card>
                    <Card>
                        <h5>閃電生成設定</h5>
                        <Divider />
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">起始經度 :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityLongitude} onChange={(e) => props.setEntityLongitude(e.target.value)} placeholder={field.param.longitude} style={{ width: "100%" }}/>
                            </div>
                        </div>
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">起始緯度 :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityLatitude} onChange={(e) => props.setEntityLatitude(e.target.value)} placeholder={field.param.latitude} style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">生成高度 :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityHeight} onChange={(e) => props.setEntityHeight(e.target.value)} placeholder={field.param.height} style={{ width: "100%" }}/>
                            </div>
                        </div>
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">結束高度 :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityEndHeight} onChange={(e) => props.setEntityEndHeight(e.target.value)} placeholder={field.param.endHeight} style={{ width: "100%" }}/>
                            </div>
                        </div>
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">閃電週期 :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityPeriod} onChange={(e) => props.setEntityPeriod(e.target.value)} placeholder={field.period} style={{ width: "100%" }}/>
                            </div>
                        </div>
                    </Card>
                    <br></br>
                    <Card>
                        <h5>閃電顏色設定</h5>
                        <Divider />
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-2 md:mb-0">權重R :</label>
                            <div className="col-12 md:col-2">
                                <InputText value={props.entityRGBWeightR} onChange={(e) => props.setEntityRGBWeightR(e.target.value)} placeholder={field.param.RGBWeightR} style={{ width: "100%" }}/>
                            </div>

                            <label className="col-12 mb-4 md:col-2 md:mb-0">權重G :</label>
                            <div className="col-12 md:col-2">
                                <InputText value={props.entityRGBWeightG} onChange={(e) => props.setEntityRGBWeightG(e.target.value)} placeholder={field.param.RGBWeightG} style={{ width: "100%" }}/>
                            </div>

                            <label className="col-12 mb-4 md:col-2 md:mb-0">權重B :</label>
                            <div className="col-12 md:col-2">
                                <InputText value={props.entityRGBWeightB} onChange={(e) => props.setEntityRGBWeightB(e.target.value)} placeholder={field.param.RGBWeightB} style={{ width: "100%" }}/>
                            </div>
                        </div>
                    </Card>
                    <Divider />
                    <div className="field grid">
                        <div className="col-12 md:col-6">
                            <Button label="確定變更" icon="pi pi-check" className="p-button-raised p-button-info " onClick={() => { props.changeLightning(indexNum) }} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 md:col-6">
                            <Button label="捨棄變更" icon="pi pi-trash" className="p-button-raised p-button-danger " onClick={() => { props.setReChange(true)}} style={{ width: "100%" }} />
                        </div>
                    </div>
                </Card>
            </Dialog>
        )
    } else {
        return null;
    }
}